export default function ErrorState({ message = 'No se pudo cargar la información.', onRetry }) {
  return (
    <div className="state-block error" role="alert">
      <p className="empty-title">{message}</p>
      {onRetry ? (
        <button type="button" className="btn btn-secondary" onClick={onRetry}>
          Reintentar
        </button>
      ) : null}
    </div>
  );
}
